if (typeof VideoHero === 'undefined') {
  class VideoHero extends HTMLElement {
    constructor() {
      super()

      this.video = this.querySelector('video')
      this.videoOverlay = this.querySelector('.js-video-overlay')
      this.videoPoster = this.querySelector('.js-video-poster')
      this.videoToolbar = this.querySelector('.js-video-toolbar')
      this.videoPlay = this.querySelector('.js-video-play')
      this.videoPause = this.querySelector('.js-video-pause')
      this.videoUnmute = this.querySelector('.js-video-unmute')
      this.videoMute = this.querySelector('.js-video-mute')

      this.playVideo = this.playVideo.bind(this)
      this.videoPlay?.addEventListener('click', this.playVideo)
      this.videoPause.addEventListener('click', this.pauseVideo.bind(this))
      this.videoUnmute?.addEventListener('click', this.unmuteVideo.bind(this))
      this.videoMute?.addEventListener('click', this.muteVideo.bind(this))

      this.playVideo()
    }

    playVideo() {
      this.videoOverlay?.classList.add('hidden')
      this.video.play()
      this.videoToolbar.classList.remove('hidden')
    }

    pauseVideo() {
      this.videoOverlay?.classList.remove('hidden')
      this.videoPoster?.classList.add('hidden')
      this.videoToolbar.classList.add('hidden')
      this.video.pause()
    }

    unmuteVideo() {
      this.videoMute?.classList.remove('hidden')
      this.videoUnmute?.classList.add('hidden')
      this.video.setAttribute('muted', false)
    }

    muteVideo() {
      this.videoMute?.classList.add('hidden')
      this.videoUnmute?.classList.remove('hidden')
      this.video.setAttribute('muted', true)
    }
  }

  if (customElements.get('video-hero') === undefined) {
    customElements.define('video-hero', VideoHero)
  }
}
